"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UNLIMIT_RPP = exports.DEFAULT_RPP = void 0;
exports.DEFAULT_RPP = 30;
exports.UNLIMIT_RPP = 1000000;
//# sourceMappingURL=api.js.map